import { useParams } from 'react-router-dom';
import { useToast } from '@chakra-ui/react';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useGetInspectionDetailSuspense } from '../../../../services/api/generated/client';
import { localise, templateReplace } from '../../../../services/lang/lang';
import { unwrapModel } from '../../../../services/api/unwrapModel';
import { Alert } from '../../../modules/Alert/Alert';
import useCanUserViewFeature from '../../../../hooks/useCanUserViewFeature';
import { inspectionRefreshed } from '../../../../actions/inspectionDetail';
import { FIVE_MIN_STALE_TIME } from '../../../../services/api/query/queryClient';
import InspectionDetailContent from './InspectionDetailContent';
const InspectionDetailWrapper = () => {
    const dispatch = useDispatch();
    const { id: inspectionId } = useParams();
    const toast = useToast();
    const { canView: canEditInspection } = useCanUserViewFeature(['inspections.update'], parseInt(inspectionId, 10));
    const { data: response, refetch } = useGetInspectionDetailSuspense(parseInt(inspectionId, 10), {
        query: {
            staleTime: FIVE_MIN_STALE_TIME,
        },
        axios: { headers: { 'api-version': 'v3' } },
    });
    if (!response) {
        return null;
    }
    const inspection = unwrapModel(response);
    if (!inspection) {
        return (React.createElement(Alert, { "data-testid": "inspection_detail_wrapper__alert", status: "error", icon: true, title: localise('SOMETHING_WRONG') }, templateReplace(localise('RESOURCE_NOT_FOUND'), {
            noun: localise('INSPECTION'),
        })));
    }
    dispatch(inspectionRefreshed(inspection));
    const onInspectionMutated = (noun) => {
        if (noun) {
            toast({
                title: templateReplace(localise('UPDATED'), { noun }),
                status: 'success',
                isClosable: true,
            });
        }
        refetch();
    };
    return (React.createElement(InspectionDetailContent, { inspection: inspection, isShare: false, hasPermissionToEdit: canEditInspection, onInspectionMutated: onInspectionMutated }));
};
export default InspectionDetailWrapper;
